const sportToCategoryMap = {
  kab: 'kabaddi',
  fut: 'football',
};

export default sportToCategoryMap;
